module.exports = __webpack_public_path__ + "static/media/background1.d9f66832.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/background1.jpg
// module id = 257
// module chunks = 0